export default function (store, { start, mode }) {
    if (!store.existsTask(start)) {
        return;
    }
    const draggableIds = [];
    if (!store.getTask(start).selected) {
        store.in.exec("select-task", { id: start });
    }
    store.eachSelected(id => {
        draggableIds.push(id);
        const children = store.getChildrenIds({ id });
        for (const childId of children) {
            const child = store.getTask(childId);
            if (!child?.selected)
                draggableIds.push(childId);
        }
    }, true);
    for (let index = 0; index < draggableIds.length; index++) {
        store.updateTask({
            id: draggableIds[index],
            task: {
                draggable: true,
            },
            skipStateCalc: index !== draggableIds.length - 1,
        });
    }
    store.setState({ draggableIds, dragInfo: { mode } });
}
//# sourceMappingURL=start.js.map